/* eslint-disable */

import ZoomMtgEmbedded from "@zoomus/websdk/embedded";
const client = ZoomMtgEmbedded.createClient();

(function($) {
  $( document ).ready(function() {

    var role = 0,
        meetingNumber = $('.meeting-parameters').data('zoom-meeting-number'),
        signature = $('.meeting-parameters').data('zoom-signature'),
        apiKey = 'Ek7URQMjQBGTTPUbE93kgw';

    $('button[name="zoom_join"]').click(function(){

      // Check if name field has value
      var zoomName = $('input[name="zoom_name"]').val();
      var zoomPassword = $('input[name="zoom_password"]').val();
      if (zoomName) {
        let meetingSDKElement = document.getElementById('meetingSDKElement');
        client.init({
          debug: true,
          zoomAppRoot: meetingSDKElement,
          language: 'en-US',
          customize: {
            meetingInfo: ['topic', 'host', 'mn', 'pwd', 'telPwd', 'participant', 'dc', 'enctype'],
          }
        });
        client.join({
          apiKey: apiKey,
          signature: signature,
          meetingNumber: meetingNumber,
          password: zoomPassword,
          userName: zoomName,
          success: (success) => {
              console.log('success');
          },
          error: (error) => {
              console.log(error);
          }
        });
        client.muteAll({
          muteAll: true,
        })

        $('.zoom-dialog-name').hide();
        $('.zoom-dialog-joining').fadeIn('fast');

        setTimeout(function () {
          $('.zoom-credentials').hide();
          $('.zoom-meeting').show();

          $('.react-draggable').removeClass('react-draggable').addClass('h-full w-full');
          $('.drag-video').removeClass('drag-video');

        }, 3000);

      } else {
        alert('Please enter a name')
      }

    });

  });
})(jQuery);



// WEBPACK FOOTER //
// ./scripts/routes/zoom.js